/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { SessionMsg, RemoteSessionEventService } from "../../shared/common/remote-session/remote-session-event.service";
import { Injectable } from "@angular/core";

import { RDPChan, InternalChan, DummyChan } from "../../shared/desktop/channels/rdpvcbridge/vctransport";
import { BlastWmks } from "../../../webclient/shared/desktop/common/blast-wmks.service";
import { VcClientSdk } from "../../shared/desktop/channels/rdpvcbridge/vc-client/vc-client-sdk";
/**
 * This is designed for Chrome Client in Seamless window mode, thus avoid the session map
 */
@Injectable()
export class RDPVChanService {
   private inited: boolean = false;
   constructor(
      private remoteSessionEventService: RemoteSessionEventService,
      private vcClientSdk: VcClientSdk
   ) {}
   init = () => {
      if (!this.inited) {
         this.remoteSessionEventService.addEventListener(SessionMsg.SESSION_CONNECTING_MSG, this.onSessionConnecting);
         this.inited = true;
      }
      // Instead of converting here, use SDK to do reliable convertation, to handle the client closed case
      // no network recovery supported for now.
   };

   private onSessionConnecting = (wmksSession: BlastWmks) => {
      const sessionKey = wmksSession.key;
      // not use vdpService.vvcSession, and refer vvcSession directly
      const vvcSession = wmksSession.vvcSession;
      const vvc = wmksSession.vvc;
      this._createChannels(sessionKey, vvc, vvcSession);
      this._createNewDummyChan(vvc, vvcSession);
   };

   private _createChannels = (sessionKey, vvc, vvcSession) => {
      new RDPChan(sessionKey, vvc, vvcSession, this.vcClientSdk);
      new InternalChan(sessionKey, vvc, vvcSession, this.vcClientSdk);
   };

   private _createNewDummyChan = (vvc, vvcSession) => {
      return new DummyChan(vvc, vvcSession);
   };
}
